/**
 * useHelpOverlay — consumer hook for HelpOverlayContext. Split out from the
 * context file so the provider's react-refresh hygiene stays clean.
 */
import { useContext } from 'react';
import { HelpOverlayContext, type HelpOverlayContextValue } from '../contexts/HelpOverlayContext';

export function useHelpOverlay(): HelpOverlayContextValue {
  const ctx = useContext(HelpOverlayContext);
  if (!ctx) {
    throw new Error('useHelpOverlay must be used within a HelpOverlayProvider');
  }
  return ctx;
}
